import { useContext } from "react";
import { BoardContext, TeamContext } from "../../../context";
import { Phase } from "../../../util/enums";
import { CountdownTimer } from "../../atoms";
import DilemmaRoundsCounter from "../../atoms/DilemmaRoundsCounter/DilemmaRoundsCounter";
import PlayerMiniProfile from "../Player/PlayerMiniProfile";

const GameBoardHeader = () => {
    const { game } = useContext(TeamContext);
    const { instructionTutorial } = useContext(BoardContext);

    const getZIndexForGameHeader = () => {
        if (instructionTutorial === "rightSideOfTheScreen") return 21;
        if (game?.phase === Phase.QUESTION_CARD || game?.phase === Phase.CHOOSE_SOLUTION) return 26;
        return 9;
    }

    const moveFromTop = instructionTutorial === "rightSideOfTheScreen" ? '5px' : '0px';

    return (
        <div className="reusable_header_wrapper" style={{ width: "100vw", zIndex: getZIndexForGameHeader(), top: moveFromTop }}>
            <div className="component_header">

                <div className="" style={{ width: "25%" }}>
                    <PlayerMiniProfile />
                </div>

                <div style={{ width: "50%" }}>
                    
                </div>

                <div className={`slot_machine_countdown_timer_wrapper ${instructionTutorial === "rightSideOfTheScreen" && "right_side_screeen_instructions_background"} `} style={{ width: "25%" }}>
                    
                    <DilemmaRoundsCounter />
                    <CountdownTimer />
                </div>
            </div>
        </div>
    )
}

export default GameBoardHeader;